/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceIpadHorizontalSearch = createReactComponent(
  "device-ipad-horizontal-search",
  "IconDeviceIpadHorizontalSearch",
  [
    [
      "path",
      {
        d: "M11.5 20h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5",
        key: "svg-0"
      }
    ],
    ["path", { d: "M9 17h2", key: "svg-1" }],
    ["path", { d: "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-2" }],
    ["path", { d: "M20.2 20.2l1.8 1.8", key: "svg-3" }]
  ]
);

export { IconDeviceIpadHorizontalSearch as default };
//# sourceMappingURL=IconDeviceIpadHorizontalSearch.js.map
